"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GIFTING_FLOW_CACHE_KEYS = void 0;
var GIFTING_FLOW_CACHE_KEYS = {
  UPLOAD_CONTACTS_FILE: 'modules.giftingFLow.createBatchStep.uploadBulkContactsFile',
  CREATE_BATCH: 'modules.giftingFLow.createBatchStep.submit'
};
exports.GIFTING_FLOW_CACHE_KEYS = GIFTING_FLOW_CACHE_KEYS;